import { render } from "./TopDestinationBanner.vue?vue&type=template&id=53ef0614"
import script from "./TopDestinationBanner.vue?vue&type=script&lang=js"
export * from "./TopDestinationBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__